import MaxiGiga from './MaxiGiga';

export default MaxiGiga;
